import { render, staticRenderFns } from "./DashboardMerchant.vue?vue&type=template&id=ef41fe60&"
import script from "./DashboardMerchant.vue?vue&type=script&lang=js&"
export * from "./DashboardMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports